const initialValues = {
  name: "",
  desc: "",
  image: "",
  url: "",
  trial: 14,
  page: null,
};

export default initialValues;